import { confirmPayment } from "../services/payment";

const usePayment = () => {
  const handleConfirmPayment = (payload) => {
    return new Promise((resolve, reject) => {
      confirmPayment(payload)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };
  return { handleConfirmPayment };
};

export default usePayment;
